import React from "react";
import {AbsoluteFill, useCurrentFrame, useVideoConfig} from "remotion";

interface Particle {
  x: number;
  y: number;
  size: number;
  speed: number;
  opacity: number;
}

// Deterministic pseudo-random number generator
const seededRandom = (seed: number): number => {
  const x = Math.sin(seed * 9301 + 49297) * 233280;
  return x - Math.floor(x);
};

const generateParticles = (count: number, width: number, height: number): Particle[] => {
  return Array.from({length: count}, (_, i) => ({
    x: seededRandom(i * 3 + 1) * width,
    y: seededRandom(i * 3 + 2) * height,
    size: 2 + seededRandom(i * 3 + 3) * 4,
    speed: 0.2 + seededRandom(i * 3 + 4) * 0.8,
    opacity: 0.2 + seededRandom(i * 3 + 5) * 0.6,
  }));
};

export interface ParticleFieldProps {
  count?: number;
  color?: string;
  speed?: number;
  direction?: "up" | "down" | "left" | "right";
  style?: React.CSSProperties;
}

export const ParticleField: React.FC<ParticleFieldProps> = ({
  count = 50,
  color = "rgba(255,255,255,0.5)",
  speed = 1,
  direction = "up",
  style,
}) => {
  const frame = useCurrentFrame();
  const {width, height} = useVideoConfig();

  const particles = React.useMemo(
    () => generateParticles(count, width, height),
    [count, width, height],
  );

  return (
    <AbsoluteFill style={style}>
      <svg width={width} height={height}>
        {particles.map((p, i) => {
          const movement = frame * p.speed * speed;
          let cx = p.x;
          let cy = p.y;

          switch (direction) {
            case "up":
              cy = ((p.y - movement) % height + height) % height;
              break;
            case "down":
              cy = (p.y + movement) % height;
              break;
            case "left":
              cx = ((p.x - movement) % width + width) % width;
              break;
            case "right":
              cx = (p.x + movement) % width;
              break;
          }

          return (
            <circle
              key={i}
              cx={cx}
              cy={cy}
              r={p.size}
              fill={color}
              opacity={p.opacity}
            />
          );
        })}
      </svg>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
